import {
  // -- GET (list)
  GET_PROJECT_PRODUCTS_SUCCESS,
  GET_PROJECT_PRODUCTS_FAILURE,
  // -- CREATE
  CREATE_PROJECT_PRODUCT_SUCCESS,
  CREATE_PROJECT_PRODUCT_FAILURE,
  // -- UPDATE
  UPDATE_PROJECT_PRODUCT_SUCCESS,
  UPDATE_PROJECT_PRODUCT_FAILURE,
  // -- DELETE
  DELETE_PROJECT_PRODUCT_SUCCESS,
  DELETE_PROJECT_PRODUCT_FAILURE,
  // -- SEARCH
  SEARCH_PROJECT_PRODUCTS
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'

let cacheItems = null

export const projectProducts = (state = {}, action) => {
  switch (action.type) {
    // -- GET PROJECT PRODUCTS (list)
    case GET_PROJECT_PRODUCTS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectProducts.GET_PROJECT_PRODUCTS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_PROJECT_PRODUCTS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectProducts.GET_PROJECT_PRODUCTS_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE PROJECT PRODUCT
    case CREATE_PROJECT_PRODUCT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectProducts.CREATE_PROJECT_PRODUCT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_PROJECT_PRODUCT_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectProducts.CREATE_PROJECT_PRODUCT_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE PROJECT PRODUCT
    case UPDATE_PROJECT_PRODUCT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectProducts.UPDATE_PROJECT_PRODUCT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_PROJECT_PRODUCT_SUCCESS: {
      const items = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectProducts.UPDATE_PROJECT_PRODUCT_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- DELETE PROJECT PRODUCT
    case DELETE_PROJECT_PRODUCT_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectProducts.DELETE_PROJECT_PRODUCT_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_PROJECT_PRODUCT_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectProducts.DELETE_PROJECT_PRODUCT_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- SEARCH PROJECT
    case SEARCH_PROJECT_PRODUCTS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }

    default:
      return state
  }
}
